// extracted by css-extract-rspack-plugin
export default {"container":"WpkkU61lZ742hfK1","zoomDisabled":"NFvPQItgXSASkT7K"};